<script lang="ts">
import { defineComponent } from 'vue'

import { opChain } from '@collector/shared-utils'
import { Basketball3x3IncidentId } from '@collector/sportsapi-client-legacy'
import IncidentButton from '@mobile/views/Relation/Shared/IncidentButton/IncidentButton.vue'

import { useBasketBall3x3Configuration } from '../../BasketballRelationDependencies/useBasketBallConfiguration'

export default defineComponent({
  components: { IncidentButton },
  setup() {
    const { activeParticipant, inactiveParticipant } =
      useBasketBall3x3Configuration()

    return {
      activeParticipant,
      inactiveParticipant,
      Basketball3x3IncidentId,
      opChain,
    }
  },
})
</script>

<template>
  <div class="grid gap-4">
    <IncidentButton
      class="h-full"
      :type="'vertical'"
      :size="'xs'"
      :color="'white'"
      :incidentId="Basketball3x3IncidentId.Foul"
    />
    <IncidentButton
      class="h-full"
      :type="'vertical'"
      :size="'xs'"
      :color="'white'"
      :participantId="opChain(activeParticipant.participant, (v) => v.id)"
      :incidentId="Basketball3x3IncidentId.Turnover"
    >
      TO
    </IncidentButton>
    <IncidentButton
      class="h-full"
      :type="'vertical'"
      :size="'xs'"
      :color="'white'"
      :participantId="opChain(inactiveParticipant.participant, (v) => v.id)"
      :incidentId="Basketball3x3IncidentId.Steal"
    />
  </div>
  <div class="grid gap-4">
    <IncidentButton
      class="col-span-2 h-full"
      :type="'horizontal'"
      :size="'xs'"
      :participantId="opChain(activeParticipant.participant, (v) => v.id)"
      :incidentId="Basketball3x3IncidentId.OnePointShotMade"
    >
      <div class="flex w-full items-center justify-between">
        <span>1pts</span>
        <FontAwesomeIcon
          class="text-green text-lg"
          icon="check"
        />
      </div>
    </IncidentButton>
    <IncidentButton
      class="col-span-2 h-full"
      :type="'horizontal'"
      :size="'xs'"
      :color="'white'"
      :participantId="opChain(activeParticipant.participant, (v) => v.id)"
      :incidentId="Basketball3x3IncidentId.TwoPointShotMade"
    >
      <div class="flex w-full items-center justify-between">
        <span>2pts</span>
        <FontAwesomeIcon
          class="text-green text-lg"
          icon="check"
        />
      </div>
    </IncidentButton>
    <IncidentButton
      class="col-span-2 h-full"
      :type="'horizontal'"
      :size="'xs'"
      :color="'white'"
      :participantId="opChain(activeParticipant.participant, (v) => v.id)"
      :incidentId="Basketball3x3IncidentId.FreeThrowIn"
    >
      <div class="flex w-full items-center justify-between">
        <span>FT</span>
        <FontAwesomeIcon
          class="text-green text-lg"
          icon="check"
        />
      </div>
    </IncidentButton>
  </div>
</template>
